<script>
  import {
    state,
    taxi,
    praxi,
    planetInfoFlag,
    planetIndex,
    fullScreen,
  } from '../js/stores.js'
  import { _, json } from 'svelte-i18n'
  import { derived } from 'svelte/store'
  import { gsap, Power1 } from 'gsap'
  import { animateBgColor } from '../js/animations.js'
  import { onMount } from 'svelte'

  // import { toggleFullScreen, isFullScreen } from "../js/functions"

  let isFullScreen = false

  $: {
    $planetIndex,
      setTimeout(() => {
        animateBgColor(document.getElementById('toggle'), '#ff7941', 3, 1)
      }, 300)
  }

  const score = derived(
    state,
    ({ scorePositive, scoreNegative }) => scorePositive - scoreNegative,
  )

  // $: if ($planetInfoFlag) {
  //   setTimeout(() => {
  //     target = document.getElementById("planet-" + $planetIndex)
  //     target.parentNode.scrollTop = target.offsetTop
  //   }, 500)
  // }

  $: if ($planetInfoFlag) {
    plausible('PlanetInfo', {
      props: {
        taxi: $taxi,
        praxi: $praxi,
      },
    })
  }

  $: gsap.to('#score-number', {
    duration: 0.5,
    innerText: $score,
    snap: { innerText: 1 },
    ease: 'power1',
  })

  // function handleKeydown(event) {
  //   let key = event.key
  //   let keyCode = event.keyCode

  //   console.log(key)
  //   console.log(keyCode)

  //   // Escape
  //   if (keyCode === 27) {
  //     $fullScreen = false
  //   }

  //   // F12
  //   if (keyCode === 122) {
  //     $fullScreen = !$fullScreen
  //   }
  // }

  function toggleFullScreen() {
    if (isFullScreen) {
      document.exitFullscreen()
      // console.log('exiting FullScreen')
      plausible('FullScreen', {
        props: {
          action: 'exit',
        },
      })
    } else {
      document.documentElement.requestFullscreen()
      // console.log('entered FullScreen')
      plausible('FullScreen', {
        props: {
          action: 'enter',
        },
      })
    }
  }

  onMount(() => {
    isFullScreen = document.fullscreenElement ? true : false

    // Listen for changes to the fullscreen mode
    document.addEventListener('fullscreenchange', () => {
      // Update the text of the button
      isFullScreen = document.fullscreenElement ? true : false
    })

    // Listen for the keydown event on the document
    document.addEventListener('keydown', (event) => {
      // Check if the key that was pressed is the F11 key
      if (event.key === 'F11') {
        // If it is, prevent the default behavior of the key
        event.preventDefault()
      }
    })
  })
</script>

<style>
  .fullscreen img {
    cursor: pointer;
    width: 18px;
  }

  .planet {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .toggle {
    margin-left: 10px;
    /* width: 100px; */
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid white;
    background: none;
    padding: 2px 6px;
    border-radius: 5px;
    color: white;
    cursor: pointer;
  }

  .toggle svg {
    margin-right: 5px;
  }

  .bar {
    position: fixed;
    top: 0;
    left: 0;
    padding: 14px 24px;
    background-color: rgba(0, 0, 0, 0.4);
    width: 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 1.5rem;
  }

  svg {
    width: 25px;
    height: 25px;
  }

  a {
    color: white;
  }

  a:hover {
    color: #ff7940;
  }

  @media (max-width: 600px) {
    .fullscreen img {
      width: 12px;
    }

    .bar * {
      font-size: 1rem;
    }

    .toggle {
      margin-left: 2px;
    }

    svg {
      width: 16px;
      height: 16px;
    }
  }

  @media (max-width: 350px) {
    .fullscreen img {
      width: 8px;
    }

    .bar * {
      font-size: 0.7rem;
    }

    .toggle {
      margin-left: 0px;
    }

    svg {
      width: 12px;
      height: 12px;
    }
  }
</style>

<!-- <svelte:window on:keydown={handleKeydown} /> -->

<div class="bar">
  <div class="planet">
    {$json('planetNames')[$state.planetIndex - 1] ? $json('planetNames')[$state.planetIndex - 1] : $_('gameTitle')}
    {#if $json('planetNames')[$state.planetIndex - 1]}
      {#if !$planetInfoFlag}
        <button
          id="toggle"
          class="toggle"
          on:click={() => {
            $planetInfoFlag = true
          }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542
              7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          {$_('view')}
        </button>
      {:else}
        <button
          id="toggle"
          class="toggle"
          on:click={() => {
            $planetInfoFlag = false
          }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor">
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm.707-10.293a1 1 0
              00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L9.414
              11H13a1 1 0 100-2H9.414l1.293-1.293z"
              clip-rule="evenodd" />
          </svg>
          {$_('back')}
        </button>
      {/if}
    {/if}
  </div>
  {#if $taxi}
    <div>
      <a
        href="/"
        on:click={() => {
          $state.restartClicked = true
          return confirm($_('startOverPrompt'))
        }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11
            11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
      </a>
    </div>
    {#if !mobile}
      <div class="fullscreen">
        <img
          src="images/{isFullScreen ? 'exit-fullscreen' : 'fullscreen'}.svg"
          alt={$_('toggleFullScreen')}
          title={$_('toggleFullScreen')}
          on:click={toggleFullScreen} />
      </div>
    {/if}
    <div class="score">
      {$_('points')}
      <span id="score-number">{$score}</span>
    </div>
  {/if}
</div>

<!-- <svelte:window on:keydown={handleKeydown} /> -->
